"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgPeople = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("g", { strokeWidth: 1.0214 },
            React.createElement("rect", { x: 17.222, y: 14.497, width: 6.2669, height: 5.9925, rx: 1.5667 }),
            React.createElement("rect", { x: 8.8665, y: 11.501, width: 6.2669, height: 8.9887, rx: 1.5667 }),
            React.createElement("rect", { x: 0.51068, y: 13.498, width: 6.2669, height: 6.9912, rx: 1.5667 }),
            React.createElement("ellipse", { cx: 12, cy: 6.5069, rx: 3.1335, ry: 2.9962 }),
            React.createElement("ellipse", { cx: 20.356, cy: 9.5031, rx: 3.1335, ry: 2.9962 }),
            React.createElement("ellipse", { cx: 3.6441, cy: 8.5044, rx: 3.1335, ry: 2.9962 })))));
exports.default = SvgPeople;
//# sourceMappingURL=People.js.map